export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const GET_ALL_COMMENTS = 'GET_ALL_COMMENTS'
export const GET_ALL_REPLY_COMMENTS = 'GET_ALL_REPLY_COMMENTS'
